import locationSettlement from '@/api/location-settlement'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  warehouses: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_WAREHOUSES(state, data) {
    state.warehouses = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return locationSettlement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return locationSettlement.store(data)
  },

  update(context, data) {
    return locationSettlement.update(data)
  },
  destroy(context, id) {
    return locationSettlement.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await locationSettlement.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.warehouses.length > 0) {
      let response = await locationSettlement.warehouse()
      context.commit('SET_WAREHOUSES', response)
    }
  }
}
